import type { SVGProps } from 'react';
import * as React from 'react';
const SvgIconLogoPowerpoint = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="#ED6C47" d="M14.093 12.93 12.697 2.698h-.104a9.225 9.225 0 0 0-9.198 9.198V12z" />
    <path fill="#FF8F6B" d="M12.801 2.698h-.104V12l4.651 1.86L22 12v-.104a9.225 9.225 0 0 0-9.198-9.198" />
    <path fill="#D35230" d="M22 12v.102a9.226 9.226 0 0 1-9.2 9.2h-.205a9.227 9.227 0 0 1-9.2-9.2V12z" />
    <path
      fill="#000"
      d="M13.162 7.27v9.925a.856.856 0 0 1-.85.852H5.59a9.123 9.123 0 0 1-2.195-5.944v-.205a9.1 9.1 0 0 1 1.498-5.014 6 6 0 0 1 .325-.465h7.093a.86.86 0 0 1 .851.85"
      opacity={0.1}
    />
    <path
      fill="#000"
      d="M12.697 7.735v9.925a.856.856 0 0 1-.851.851H6.014a8 8 0 0 1-.424-.465 9.123 9.123 0 0 1-2.195-5.944v-.204a9.1 9.1 0 0 1 1.498-5.014h6.953a.86.86 0 0 1 .851.85"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M12.697 7.735v8.995a.86.86 0 0 1-.85.851H5.217a9.12 9.12 0 0 1-1.823-5.479v-.204a9.1 9.1 0 0 1 1.498-5.014h6.953a.86.86 0 0 1 .851.85"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M12.232 7.735v8.995a.86.86 0 0 1-.851.851H5.218a9.12 9.12 0 0 1-1.823-5.479v-.204a9.1 9.1 0 0 1 1.498-5.014h6.488a.86.86 0 0 1 .851.85"
      opacity={0.2}
    />
    <path
      fill="#CA4C28"
      d="M2.852 6.884h8.528c.47 0 .852.381.852.852v8.528c0 .47-.382.852-.852.852H2.851A.853.853 0 0 1 2 16.264V7.736c0-.47.381-.852.852-.852"
    />
    <path
      fill="#fff"
      d="M7.209 9.158a2.34 2.34 0 0 1 1.552.455c.373.333.572.818.54 1.317.007.347-.086.688-.266.985a1.8 1.8 0 0 1-.757.669 2.6 2.6 0 0 1-1.138.239H6.062v2.004H4.957v-5.67zM6.06 11.957h.95c.302.022.601-.067.841-.25a.93.93 0 0 0 .284-.734q0-.938-1.09-.938h-.985z"
    />
  </svg>
);
export default SvgIconLogoPowerpoint;
